import Vue from 'vue';
// import Router from 'vue-router';
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import AppSettings from './views/AppSettings.vue';
import Settings from './views/Settings.vue';
import Login from './views/Login.vue';
import SalesReview from './views/SalesReview.vue';
import Dashboard from './views/Dashboard.vue';
import Bookings from './views/Booking.vue';
import Settlements from './views/Settlements.vue';
import AutoApprove from './views/AutoApprove.vue';
import BookingPrograms from './views/BookingPrograms.vue';
import CompanyAgreementSendingConfiguration from './views/CompanyAgreementSendingConfiguration.vue';
import SalesOrderRemarksConfiguration from './views/SalesOrderRemarksConfiguration.vue';
import DateRangeConfiguration from './views/DateRangeConfiguration.vue';



// breakchanges of vue2
// Vue.use(Router);

const routes :any = [
  {
    path: '/',
    redirect: {
      name: 'login',
    },
  },
  {
    path: '/appSettings',
    name: 'appSettings',
    component: AppSettings,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
  },
  {
    path: '/salesReview',
    name: 'salesReview',
    component: SalesReview,
    props: true,
    children: [
      {
        path: '',
        redirect: {
          name: 'dashboard'
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        alias: '/',
      },
      {
        path: '/settings',
        name: 'settings',
        component: Settings,
      },
      {
        path: '/autoapprove',
        name: 'autoApprove',
        component: AutoApprove,
      },
      {
        path: '/bookingPrograms',
        name: 'bookingPrograms',
        component: BookingPrograms,
      },
      {
        path: '/CompanyAgreementSendingConfiguration',
        name: 'CompanyAgreementSendingConfiguration',
        component: CompanyAgreementSendingConfiguration,
      },
      {
        path: '/salesorderremarksconfiguration',
        name: 'salesorderremarksconfiguration',
        component: SalesOrderRemarksConfiguration,
      },
      {
        path: '/DateRangeConfiguration',
        name: 'DateRange',
        component: DateRangeConfiguration,
      },
      {
        path: '/bookings/:id',
        name: 'bookings',
        component: Bookings,
        props: true,
      },
      {
        path: '/settlements/:id',
        name: 'settlements',
        component: Settlements,
      },
    ],
  },
];

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes: [
//     {
//       path: '/',
//       name: 'login',
//       component: () => import("./views/Login.vue"),
      
//     },
//     {
//       path: '/appSettings',
//       name: 'appSettings',
//       component:  () => import("./views/AppSettings.vue"),
//     },
//     {
//       path: '/login',
//       name: 'login',
//       component: () => import("./views/Login.vue"),
//       props: true,
//     },
//     {
//       path: '/salesReview',
//       name: 'salesReview',
//       component: () => import("./views/SalesReview.vue"),
//       props: true,
//       children: [
//         {
//           path: '/dashboard',
//           name: 'dashboard',
//           component: () => import("./views/Dashboard.vue"),
//           alias: '/',
//         },
//         {
//           path: '/settings',
//           name: 'settings',
//           component: () => import("./views/Settings.vue"),
//         },
//         {
//           path: '/autoapprove',
//           name: 'autoApprove',
//           component: () => import("./views/AutoApprove.vue"),
//         },
//         {
//           path: '/bookingPrograms',
//           name: 'bookingPrograms',
//           component: () => import("./views/BookingPrograms.vue"),
//         },
//         {
//           path: '/CompanyAgreementSendingConfiguration',
//           name: 'CompanyAgreementSendingConfiguration',
//           component: () => import("./views/CompanyAgreementSendingConfiguration.vue"),
//         },
//         {
//           path: '/salesorderremarksconfiguration',
//           name: 'salesorderremarksconfiguration',
//           component: () => import("./views/SalesOrderRemarksConfiguration.vue"),
//         },
//         {
//           path: '/DateRangeConfiguration',
//           name: 'DateRange',
//           component: () => import("./views/DateRangeConfiguration.vue"),
//         },
//         {
//           path: '/bookings/:id',
//           name: 'bookings',
//           component: () => import("./views/Booking.vue"),
//           props: true,
//         },
//         {
//           path: '/settlements/:id',
//           name: 'settlements',
//           component: () => import("./views/Settlements.vue"),
//         },
//       ],
//     },
//   ],
// });


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/appSettings'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.usertData;

  if (authRequired && !loggedIn) {
    return next('/login');
  }
  return next();
});
export default router;
